import type { Theme } from '@emotion/react';

import { ACHIEVEMENT_TIERS } from '@didaskill/domain/user-achievements/constants';
import type { Color } from '@didaskill/types/web';

export const TIER_STARS_COLOR_GROUP_MAP = (theme: Theme): Record<ACHIEVEMENT_TIERS, Color> => ({
  [ACHIEVEMENT_TIERS.NEUTRAL]: theme.colors.primary,
  [ACHIEVEMENT_TIERS.BRONZE]: theme.colors.secondary,
  [ACHIEVEMENT_TIERS.SILVER]: theme.colors.tertiary,
  [ACHIEVEMENT_TIERS.GOLD]: theme.colors.warning,
  [ACHIEVEMENT_TIERS.QUEST]: theme.colors.primary,
});
